import {
  Button,
  Divider,
  Drawer,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import Link from "@mui/material/Link";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import "../BrandProperties/BrandProperties.css";
import BrandPropertiesForm from "./BrandPropertiesForm";
import BrandPropertiesInstructions from "./BrandPropertiesInstructions";
import React, { useEffect, useMemo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import BrandPropertiesSkeleton from "../BrandSkeletons/BrandPropertiesSkeleton";
import { useCopyToClipboard } from "../brandPropertiesHook/useCopyToClipboard";
import { useBrandProperties } from "../brandPropertiesHook/useBrandProperties";
//import dayjs from "dayjs";

const BrandProperties = () => {
  const [searchParams] = useSearchParams();
  const { copied, copy } = useCopyToClipboard(); // Custom hook for clipboard copy
  const { getBrandPropertiesAndRequirements } = useBrandProperties();

  const brandSharedUid = searchParams.get("brandSharedUid") as any;
  const bkInterfaceSharedUid = searchParams.get("bkInterfaceSharedUid") as any;
  const {
    brandConfigurationReportList,
    brandPropertiesData,
    brandBackendRequirementsData,
    brandConfigReportLoader,
  } = useSelector((state: any) => state.brandConfigurationReport);

  const [open, setOpen] = React.useState(false);
  const keeperId = brandPropertiesData?.[0]?.keeper?.keeper_id;
  const brandDetailsMap = useMemo(() => {
    if (!brandConfigurationReportList?.length) return new Map();

    const map = new Map();
    brandConfigurationReportList.forEach((item: any) => {
      map.set(item.brand_shared_uid, item);
    });
    return map;
  }, [brandConfigurationReportList]);

  const brandDetails = brandDetailsMap.get(brandSharedUid) ?? null;
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  // Fetch brand properties and backend requirements
  useEffect(() => {
    getBrandPropertiesAndRequirements();
    // eslint-disable-next-line
  }, [brandSharedUid, bkInterfaceSharedUid]);

  return (
    <>
      {brandConfigReportLoader || !brandDetails ? (
        <>
          <BrandPropertiesSkeleton />
        </>
      ) : (
        <>
          <Paper sx={{ p: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="h5">
                {brandDetails?.brands__name} - Brand Properties
              </Typography>
              <Link
                data-tracker="632"
                variant="body1"
                color="secondary"
                sx={{ textTransform: "uppercase", ml: 2, fontWeight: 500 }}
                href="#"
                onClick={toggleDrawer(true)}
              >
                detailed instructions
              </Link>
            </Box>
            <Typography className="brandInfo" my={1} variant="body1">
              {brandBackendRequirementsData?.[0]?.interface_name && (
                <>
                  Affiliate System:{" "}
                  <b>{brandBackendRequirementsData?.[0]?.interface_name}</b>
                </>
              )}
              {brandPropertiesData?.[0]?.brand_id && (
                <>
                  Brand ID: <b>{brandPropertiesData?.[0]?.brand_id}</b>
                </>
              )}
              {/* Updated On:{" "}
              <b>
                {brandDetails?.modified
                  ? dayjs(brandDetails?.modified).format("DD/MM/YYYY")
                  : ""}{" "}
              </b> */}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body1" mr={2}>
                {brandPropertiesData?.[0]?.keeper?.username && (
                  <>
                    Account Username:{" "}
                    <b>{brandPropertiesData?.[0]?.keeper?.username}</b>
                  </>
                )}
              </Typography>
              {brandPropertiesData?.[0]?.keeper?.keeper_id && (
                <>
                  <Button
                    data-tracker="631"
                    variant="outlined"
                    color="secondary"
                    endIcon={<ContentCopyIcon />}
                    onClick={() => copy(keeperId)}
                  >
                    {copied ? "Copied!" : "Copy keeper id"}
                  </Button>
                </>
              )}
            </Box>
            <Divider sx={{ my: 3 }} />

            <BrandPropertiesForm />

            <Drawer
              open={open}
              onClose={toggleDrawer(false)}
              sx={{ zIndex: "99999" }}
              anchor="right"
            >
              <Box
                sx={{
                  position: "absolute",
                  right: 10,
                  top: 10,
                }}
              >
                <IconButton onClick={toggleDrawer(false)}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <BrandPropertiesInstructions />
            </Drawer>
          </Paper>
        </>
      )}
    </>
  );
};

export default BrandProperties;
